import React, { useState, useEffect } from 'react';
import styles from '../styles/SensitiveThumbnail.module.css';

function EyeOffIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a21.8 21.8 0 0 1 5.06-6.06M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a21.6 21.6 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
            <line x1="1" y1="1" x2="23" y2="23" />
        </svg>
    );
}

function ImageOffIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <circle cx="9" cy="9" r="2" />
            <path d="m21 15-5-5L5 21" />
        </svg>
    );
}

// Fallback cuando la imagen de origen (feed de afiliados, tienda vendedora)
// no carga -- confirmado en real (2026-09-12): no es un bug nuestro, algunas
// tiendas (Phone House) sirven su propio CDN de imagenes con errores
// intermitentes (402 en parte de sus URLs, con y sin parametros de resize),
// nada que Esganga pueda arreglar desde el import. Sin esto, el navegador
// muestra su icono de "imagen rota" por defecto -- aqui se sustituye por un
// aviso neutro para no dar sensacion de pagina averiada.
function NoImagePlaceholder({ className }) {
    return (
        <span className={`${className || ''} ${styles.noImage}`}>
            <ImageOffIcon />
            <span>Sin imagen</span>
        </span>
    );
}

// Diversual/Lovense/Bijoux Indiscrets (categoria erotico-adultos, +18) se
// muestran sin ocultar del listado ni de la ficha -- el titulo/precio son
// siempre visibles, solo la imagen se difumina por defecto con un boton para
// revelarla, mismo patron ya usado por competidores del sector (Chollometro)
// en vez de un muro de edad o una seccion aparte escondida. Componente
// compartido (listado y ficha de detalle) para que ninguna de las dos pueda
// olvidarse de censurar.
export default function SensitiveThumbnail({ isSensitive, className, alt, src, ...imgProps }) {
    const [revealed, setRevealed] = useState(false);
    const [failed, setFailed] = useState(false);

    // Si el mismo componente recibe una src distinta (listas que reutilizan
    // la instancia en vez de remontarla), no debe arrastrar el fallo de la
    // imagen anterior.
    useEffect(() => {
        setFailed(false);
    }, [src]);

    if (!src || failed) {
        return <NoImagePlaceholder className={className} />;
    }

    if (!isSensitive || revealed) {
        return <img {...imgProps} src={src} alt={alt} className={className} onError={() => setFailed(true)} />;
    }

    return (
        <span className={styles.frame}>
            <img {...imgProps} src={src} alt={alt} className={`${className || ''} ${styles.sensitiveImage}`} onError={() => setFailed(true)} />
            <button
                type="button"
                className={styles.sensitiveReveal}
                onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    setRevealed(true);
                }}
            >
                <EyeOffIcon />
                <span>Ver imagen</span>
            </button>
        </span>
    );
}
